import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import * as React from 'react'

export default function ArrivalDateTimeFieldValue({
  value,
  setValue,
  title,
  isDisable,
  arrivalTimezone
}) {
  console.log('valueArrival:', value)
  console.log('valueArrival dayjs:', dayjs(value))
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
        <DateTimePicker
          disabled={isDisable}
          timezone={arrivalTimezone}
          value={dayjs(value)}
          onChange={(value) => setValue(value)}
          sx={{
            minHeight: '50px', // Ensure enough space
            '& .MuiInputLabel-root': {
              color: '#212529',
              padding: '4px' // Adjust padding instead of height
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: '#212529'
            },
            '& .MuiOutlinedInput-root': {
              height: '43px',
              '& fieldset': {
                borderColor: '#ccc'
              },
              '&:hover fieldset': {
                borderColor: '#a3a3a3b3', // Border color on focus
                borderWidth: '0.3px' // Border color on hover // Border color on hover
              },
              '&.Mui-focused fieldset': {
                borderColor: '#a3a3a3b3', // Border color on focus
                borderWidth: '0.3px'
              }
            },
            '& .MuiInputBase-input::placeholder': {
              fontFamily: '"Poppins", sans-serif',
              fontSize: '12px',
              fontWeight: '400',
              color: '#858585'
            }
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}
